import React from 'react';
import { withTranslation } from '../../lib/translate';
import Layout from '../../components/layout';
import { connect } from 'react-redux';
import { IonButton, IonCol, IonGrid, IonIcon, IonRow } from '@ionic/react';
import { arrowForward, checkmarkCircle, timeOutline } from 'ionicons/icons';
import { NormalText, SmallText, Spacer, StrongText, Subtitle, Title } from '../../components/common';
import Basket from '../../lib/basket';
import moment from '../../lib/moment';
import './index.css';
import { forwardTo, goBack, openExternalLink } from '../../lib/utils';
import { registerRequest } from '../../store/actions';
import Loading from '../../components/spinner';
import { Capacitor } from '@capacitor/core';
import { CREATE_ORDER } from '../../store/constants';
import { getConfig } from '../../appConfig';
import { ReactComponent as VoucherRecipient } from '../../assets/images/voucher-recipient.svg';
import { ReactComponent as VoucherDate } from '../../assets/images/voucher-date.svg';
import { ReactComponent as VoucherExpiry } from '../../assets/images/voucher-expiry.svg';
import { ReactComponent as Delivery } from '../../assets/images/delivery.svg';

import { ReactComponent as EditIcon } from '../../assets/images/edit-icon.svg';
import BlockSeparator from '../../components/blockSeparator';

const isWeb = () => Capacitor.getPlatform() === 'web';
class GiftVoucherOverview extends React.Component {
	resendGiftVoucher = () => {
		const voucher = this.props?.location.state?.voucher || Basket.gift_voucher_data;
		const { dispatch } = this.props;
		const data = {
			gift_id: voucher.id,
			recipient_email: voucher.recipient_email,
			personal_message: voucher.personal_message,
			send_on_date: voucher.send_on_date,
		};
		dispatch({
			type: 'RESEND_GIFT_VOUCHER',
			data,
		});
	};
	componentDidMount() {
		if (!this.props.giftVoucherData && !this.props.location?.state?.voucherCreated) {
			forwardTo('/gift-vouchers')
		}
		if (this.props?.location.state?.voucher?.address && !Basket.delivery_address) {
			Basket.setDeliveryAddress(this.props?.location.state?.voucher.address)
			Basket.setDigitalGift(true)
		}
		if (this.props?.location.state?.voucher?.delivery_price && !Basket.delivery_price) {
			Basket.setDeliveryPrice(parseFloat(this.props?.location.state?.voucher.delivery_price / 100).toFixed(2))

		}
	}
	handleVoucherPay = () => {
		const voucher = this.props?.location.state?.voucher || Basket.gift_voucher_data;
		if (this.props.auth.loggedIn) {
			if (!isWeb() && getConfig()?.nativePayment?.isVisible) {
				this.props.dispatch({ type: CREATE_ORDER, paymentType: 'NativePayment' });
			} else {
				forwardTo('/checkout', { giftVoucher: voucher });
			}
		} else {
			const timestamp = new Date().getTime();

			const guestUserData = {
				guest_email: `${timestamp}_${voucher.sender_email}`,
				guest_first_name: voucher.sender_name,
				guest_accepted_terms_and_conditions: true,
				guest_mobile: '',
			};

			this.handleGuestReigister(guestUserData);
		}
	};
	handleGuestReigister(guestUserData) {
		const { registerFormData } = this.props;
		const timestamp = new Date().getTime();
		const { guest_first_name, guest_mobile, guest_accepted_terms_and_conditions } = guestUserData;
		let guest_email = guestUserData.guest_email == '' || !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i.test(guestUserData.guest_email) ? 'guest@5loyalty.com' : guestUserData.guest_email;
		registerFormData.email = `${timestamp}_${guest_email}`;
		registerFormData.first_name = guest_first_name;
		registerFormData.mobile = guest_mobile;
		registerFormData.accepted_terms_and_conditions = guest_accepted_terms_and_conditions;
		registerFormData.guest = true;
		registerFormData.password = timestamp;
		this.props.dispatch(registerRequest({ referrer: '/checkout' }));
	}
	getReturnState = () => ({
		referrer: '/gift-voucher',
		referrerState: { ...this.props.location?.state, voucher: this.props?.location.state?.voucher || Basket.gift_voucher_data },
	});
	handleSignUpBannerClick = (link) => {
		if (!link) {
			forwardTo('/register', this.getReturnState());
		} else if (link.startsWith('/')) {
			forwardTo(link, this.getReturnState());
		} else {
			openExternalLink(link);
		}
	};
	backHandler(voucher) {
		if (this.props.location && this.props.location.state && this.props.location.state.redirectedFromCheckout) {
			forwardTo('/gift-vouchers', { voucher: voucher, isSent: this.props?.location?.state?.isSent, postalDelivery: this.props.location?.state?.postalDelivery || false });
		} else if (this.props.location?.state?.voucherCreated) {
			forwardTo('/sent-vouchers')
		} else {
			goBack();
		}
	};
	render() {
		const { __ } = this.props;
		const voucher = this.props?.location.state?.voucher || Basket.gift_voucher_data;
		return (
			<Loading>
				<Layout headerWithTitle showHamburger={!!this.props.location?.state?.voucherCreated} title={__('Your voucher')} color="transparent" backHandler={() => this.backHandler(voucher)} >
					<div className="absolute-content scrollable-y box-with-shadow">
						<Title className="web-only page-title-centered">{__('Your voucher')}</Title>

						{this.props.location?.state?.voucherCreated && (
							<>
								<div className="box-content on-creating-success">
									<IonIcon icon={checkmarkCircle}></IonIcon>
									<div>
										<StrongText className="block text-to-update">{__('Gift voucher ordered')}</StrongText>
										<Spacer size={0} />
										<SmallText>{`${__(voucher.address ? 'The voucher will arrive on' : 'The voucher will be sent on')} ${moment(voucher.send_on_date).format('LLLL')}${voucher.send_on_time ? ` ${__('at')} ${moment(voucher.send_on_time, 'HH:mm').format('LT')}` : ''}`}</SmallText>
									</div>
								</div>
								<Spacer size={5} />
							</>
						)}
						<div className="box-content " style={{ padding: '0' }}>
							<div className="gift-voucher-order-content" style={{ padding: 'var(--ion-padding)' }}>
								<div className="gift-voucher-order-content-summary">
									<div className='gift-voucher-summary-header'>
										<StrongText >
											{Basket.formatPrice(voucher.points_value / 100)} {__('gift voucher')}
										</StrongText>
										{this.props?.location?.state?.hasEdit && (
											<div
												className="underlined pointer"
												onClick={() => {
													forwardTo('/gift-vouchers', { voucher, isSent: this.props?.location?.state?.isSent, postalDelivery: this.props.location?.state?.postalDelivery || false });
												}}
											>
												<EditIcon className='fill-label' />
											</div>
										)}
									</div>

									<Spacer size={3} />
									<div>
										<VoucherRecipient />
										<div>
											<StrongText>{__('Recipient:')}</StrongText>
											<NormalText className='label-color'>{voucher.recipient_email}</NormalText>
										</div>

									</div>
									<Spacer size={2} />
									<div>
										<VoucherDate />
										<div>
											<StrongText>{voucher.address ? __('Delivery date:') : __('Send date:')}</StrongText>
											<NormalText className='label-color'>{moment(voucher.send_on_date).format('LLLL')}{voucher.send_on_time && ` ${__('at')} ${moment(voucher.send_on_time, 'HH:mm').format('LT')}`}</NormalText>
										</div>

									</div>
									<Spacer size={2} />
									{/* eGiftVoucherExpiry 0 means the voucher never expires: no expiry row. */}
									{(voucher.expiry_date || (getConfig().general.eGiftVoucherExpiry ?? 1) > 0) && (
										<div>
											<VoucherExpiry />
											<div>
												<StrongText>{__('Expiry date:')}</StrongText>
												<NormalText className='label-color'>{voucher.expiry_date ? moment(voucher.expiry_date).format('LLLL') : moment(voucher.send_on_date).add(getConfig().general.eGiftVoucherExpiry ?? 1, 'year').format('LLLL')}</NormalText>
											</div>

										</div>
									)}
									{voucher.address &&
										<>
											<Spacer size={2} />

											<div>
												<Delivery />
												<div>
													<StrongText>{__('Delivery to:')}</StrongText>
													<NormalText style={{ wordBreak: 'break-word' }} className='label-color'>{[voucher.address.addressLine1, voucher.address.place, voucher.address.postalCode].filter(Boolean).join(', ')}</NormalText>
												</div>

											</div>
										</>

									}
								</div>
							</div>

							{voucher.personal_message && (
								<>
									<BlockSeparator fullWidth />
									<div className='gift-voucher-personal-message' style={{ padding: 'var(--ion-padding)' }}>
										<StrongText className="block">{__('Personal message')}</StrongText>
										<Spacer size={1} />
										<NormalText className='label-color'>{voucher.personal_message}</NormalText>
									</div>
								</>

							)}
						</div>
						{/* {voucher.address &&
							<>
								<Spacer size={5} />
								<StrongText className='block text-to-update'>{__('Delivery to')}</StrongText>
								<Spacer size={2} />
								<div className='box-content'>
									<StrongText>{[voucher.address.addressLine1, voucher.address.postal_code, voucher.address.place].filter(Boolean).join(', ')}</StrongText>
								</div>
							</>
						} */}
						<Spacer size={5} />
						<IonGrid className="box-content order-content-wrapper paddL">
							<IonRow>
								<IonCol><StrongText className='text-to-update'>{__('1x eGift voucher')}</StrongText></IonCol>
								<IonCol className="righted "><StrongText>{Basket.formatPrice(voucher.points_value / 100)}</StrongText></IonCol>
							</IonRow>
							{voucher.delivery_price > 0 &&
								<IonRow>
									<IonCol><StrongText className='text-to-update'>{__('Delivery')}</StrongText></IonCol>
									<IonCol className="righted "><StrongText>{Basket.formatPrice(voucher.delivery_price / 100)}</StrongText></IonCol>
								</IonRow>
							}
							{voucher.processing_fee > 0 && (
								<IonRow>
									<IonCol><StrongText className='text-to-update'>{__('Processing fee')}</StrongText></IonCol>
									<IonCol className="righted "><StrongText>{Basket.formatPrice(voucher.processing_fee / 100)}</StrongText></IonCol>
								</IonRow>
							)}
							<IonRow>
								<IonCol><StrongText className='text-to-update'>{this.props.location?.state?.voucherCreated ? __('Total') : __('Total to pay')}</StrongText></IonCol>
								<IonCol className="righted "><StrongText>{Basket.formatPrice((voucher.delivery_price + voucher.points_value + (voucher.processing_fee || 0)) / 100)}</StrongText></IonCol>
							</IonRow>
						</IonGrid>
						<Spacer size={5} />
						{this.props.location?.state?.voucherCreated && this.props.profile.is_guest && (
							<>
								<IonButton onclick={() => forwardTo('/gift-vouchers')} expand="block">
									{__('Done')}
								</IonButton>
								<Spacer />
							</>
						)}
						{!this.props.location?.state?.voucherCreated && (
							<>
								{this.props.location.state?.isSent ? (
									<>
										{!voucher.redeemed_on && voucher.is_sent ? (
											<>
												<IonButton className='button-uppercase' color="primary" onclick={() => this.resendGiftVoucher()} expand="block">
													{__('Resend')}
												</IonButton>
											</>
										) : (
											<></>
										)}
									</>
								) : (
									<IonButton className='button-uppercase' color="primary" onclick={() => this.handleVoucherPay()} expand="block">{`${__('Pay')} ${Basket.formatPrice(
										(voucher.delivery_price + voucher.points_value + voucher.processing_fee) / 100,
									)}`}</IonButton>)}
							</>
						)}

						{!this.props.auth.loggedIn && (
							<>
								<Spacer size={5} />

								{!getConfig().general.giftVoucherSignUpBanner?.hideLoginButton &&
									<>
										<IonButton fill='clear' className="link " expand="block" onclick={() => forwardTo('/login', this.getReturnState())}>
											{__('Log in')}
										</IonButton>
										<Spacer size={2} />
									</>
								}
								{getConfig().general.giftVoucherSignUpBanner ?
									<div style={{ '--banner-color': getConfig().general.giftVoucherSignUpBanner?.color || '#000000' }} className='gift-voucher-guest-banner pointer' onClick={() => this.handleSignUpBannerClick(getConfig().general.giftVoucherSignUpBanner?.link)}>
										<img src={getConfig().general.giftVoucherSignUpBanner?.image} />
										{getConfig().general.giftVoucherSignUpBanner.showSignUpText &&
											<div>
												<StrongText>{__('Don’t have an account?')}</StrongText>
												<NormalText>{__('Create an account prior to payment to view your purchased vouchers and resend if needed.')}</NormalText>
												<StrongText style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>{__('Sign up')} <IonIcon icon={arrowForward} /></StrongText>
											</div>
										}

									</div>
									:
									<>
										<NormalText className="block">
											{__('Why not log in or register an account now before you pay? This will allow you to view your sent vouchers and resend them if you need to.')}
										</NormalText>
										<Spacer size={2} />

										<IonButton fill='clear' className="link " expand="block" onclick={() => forwardTo('/register', this.getReturnState())}>
											{__('Register your account')}
										</IonButton>
									</>
								}

							</>
						)}
					</div>
				</Layout>
			</Loading>
		);
	}
}

const stateToProps = (state) => {
	return {
		auth: state.profile.auth,
		registerFormData: state.profile.registerFormData,
		profile: state.profile.profile,
		giftVoucherData: state.orders.giftVoucherData
	};
};
export default connect(stateToProps)(withTranslation(GiftVoucherOverview));
